import { Indicator } from '../../../Common/Charts/Indicator';
import { useGeneralResultsChartsDataContext } from './hooks/useGeneralResultsChartsDataContext';

export const LiveBirthsWithAnomaly = () => {
    const { chartData } = useGeneralResultsChartsDataContext();

    return (
        <Indicator
            title={'Nascidos Vivos com Anomalia'}
            indicatorValue={chartData?.indicators?.liveBirthsWithAnomaly}
            className='aligned-container'
        />
    );
};
